import { all, fork, put, select, takeLatest, call } from 'redux-saga/effects';
import { actions } from '../reducers/room';
import { fetchRooms } from '@api/room'; // call은 동기, fork는 비동기 요청
function* getRooms(action) {
    const { exhibitionId } = action; // global.ts 에서 vrType 을 받아옴
    const vrtype = yield select(state => state.global.vrtype);
    try {
        const data = yield call(fetchRooms, exhibitionId, vrtype);
        yield put({ type: actions.GET_ROOMS_SUCCESS, data });
    }
    catch (err) {
        yield put({ type: actions.GET_ROOMS_FAILURE, error: err.message });
    }
}
function* watchGetRoom() { yield takeLatest(actions.GET_ROOMS_REQUEST, getRooms); }
export default function* globalSaga() { yield all([fork(watchGetRoom)]); }
